import { render, staticRenderFns } from "./SuggestionPlayers.vue?vue&type=template&id=40ac3ab2&scoped=true&"
import script from "./SuggestionPlayers.vue?vue&type=script&lang=js&"
export * from "./SuggestionPlayers.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionPlayers.vue?vue&type=style&index=0&id=40ac3ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac3ab2",
  null
  
)

export default component.exports